import { Controller } from "@hotwired/stimulus"

// Toggles subscription page between Monthly and Annual pricing.
// All price data lives in data- attributes on the plan cards — no server calls.
export default class extends Controller {
  static targets = ["monthlyButton", "annualButton", "price", "subtext", "badge", "actionButton", "currentBadge", "changeButton"]
  static values = { currentInterval: String }

  showMonthly() {
    this.update(false)
  }

  showAnnual() {
    this.update(true)
  }

  update(isAnnual) {
    const selectedInterval = isAnnual ? "annual" : "monthly"

    // Toggle button styles
    this.monthlyButtonTarget.classList.toggle("bg-primary-600", !isAnnual)
    this.monthlyButtonTarget.classList.toggle("text-white", !isAnnual)
    this.monthlyButtonTarget.classList.toggle("bg-white", isAnnual)
    this.monthlyButtonTarget.classList.toggle("text-neutral-700", isAnnual)

    this.annualButtonTarget.classList.toggle("bg-primary-600", isAnnual)
    this.annualButtonTarget.classList.toggle("text-white", isAnnual)
    this.annualButtonTarget.classList.toggle("bg-white", !isAnnual)
    this.annualButtonTarget.classList.toggle("text-neutral-700", !isAnnual)

    // Swap prices
    this.priceTargets.forEach((el) => {
      el.textContent = isAnnual ? el.dataset.annualPrice : el.dataset.monthlyPrice
    })

    // Swap subtext
    this.subtextTargets.forEach((el) => {
      el.textContent = isAnnual ? el.dataset.annualText : el.dataset.monthlyText
    })

    // Toggle Save badge visibility — swap between inline-flex and hidden
    this.badgeTargets.forEach((el) => {
      el.classList.toggle("hidden", !isAnnual)
      el.classList.toggle("inline-flex", isAnnual)
    })

    // Swap action button plan params — handles both links (A tags) and button_to forms (FORM tags)
    this.actionButtonTargets.forEach((el) => {
      const basePlan = el.dataset.basePlan
      if (!basePlan) return

      const suffix = isAnnual ? "_annual" : "_monthly"
      const newPlan = basePlan + suffix

      if (el.tagName === "A") {
        const url = new URL(el.href)
        url.searchParams.set("plan", newPlan)
        el.href = url.toString()
      }

      if (el.tagName === "FORM") {
        let input = el.querySelector("input[name='plan']")
        if (!input) {
          input = document.createElement("input")
          input.type = "hidden"
          input.name = "plan"
          el.appendChild(input)
        }
        input.value = newPlan
      }
    })

    // Toggle current plan badge vs change button for the subscriber's own plan
    const currentInterval = this.currentIntervalValue
    const onCurrentInterval = selectedInterval === currentInterval

    this.currentBadgeTargets.forEach((el) => {
      el.classList.toggle("hidden", !onCurrentInterval)
    })

    this.changeButtonTargets.forEach((el) => {
      el.classList.toggle("hidden", onCurrentInterval)

      // Update the change button's href with the selected interval
      if (el.tagName === "A") {
        const basePlan = el.dataset.basePlan
        const url = new URL(el.href)
        url.searchParams.set("plan", basePlan + "_" + selectedInterval)
        el.href = url.toString()
      }
    })
  }
}
